// src/pages/InvestmentAccountLedger/InvestmentAccountLedgerThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getInverstmentLedgerApi } from "../../../apiservice/reports";
import { getAccountBySeachApi } from "../../../apiservice/setting";
import { currentDateEndTime, currentDateStartTime } from "../../../lib/functions";

export const fetchInvestmentAccountLedger = createAsyncThunk(
  "investmentAccountLedger/fetch",
  async ({ filters }, { rejectWithValue }) => {
    try {
      const payload = {
      accId: filters?.accId || null,
      dateFrom: currentDateStartTime(filters?.fromDate),
      dateTo: currentDateEndTime(filters?.toDate),
      };
      const res = await getInverstmentLedgerApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchInvestmentAccountsBySearch = createAsyncThunk(
  "investmentAccountLedger/fetchAccountsBySearch",
  async (search, { rejectWithValue }) => {
    try {
      const res = await getAccountBySeachApi({
        query: search.trim(),
        search: true,
        multiType: ["investment"],
      });
      return (res.data || []).map((c) => ({
        sale_id: c.acc_id,
        display_text: c.acc_name,
      }));
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
